<template>
  <EModal class="feedback-modal" v-bind="$attrs" v-on="$listeners">
    <EFeedbackForm v-bind="$props" @success="onSuccess" />
  </EModal>
</template>

<script>
import { AUTOCLOSE as AUTOCLOSE_TIMEOUT } from '~~/common/js/constants/timeouts';
import '~~/common/vue/directives/validity';
import EFeedbackForm from '~~/common/vue/components/feedback-form';
import EModal from '~~/common/vue/components/modal';

export default {
  name: 'EFeedbackModal',
  components: {
    EModal,
    EFeedbackForm,
  },
  props: EFeedbackForm.props,
  methods: {
    onSuccess() {
      setTimeout(() => {
        this.$emit('close');
      }, AUTOCLOSE_TIMEOUT);
    },
  },
};
</script>
